import { KoyouKeiyakuService } from "@/service/KoyouKeiyakuService";
import { DialogService } from "@/service/DialogService";
import { AxiosError } from "axios";
import { FormUtil } from "@/utils/FormUtil";
import { RouterConst } from "@/const/Router";
import router from "@/routers";


/*
* 削除処理
*/
export function useDelete() {

  /* 雇用契約書を削除する */
  const deleteKoyouKeiyaku = (id: number): void => {
    const srv = new KoyouKeiyakuService();
    DialogService.nowloading('処理中...');

    srv.deleteKoyouKeiyaku(id).then(res => {
      if (res !== null && res === true) {
        DialogService.info({
          text: `雇用契約書を削除しました。`
        }, true)
        .then((result) => {
          if (result.isConfirmed) {
            // 雇用契約MENU画面へ遷移する
            router.push({name: RouterConst.KOYOUKEIYAKU_MENU});
          }
        });
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し処理に失敗しました'
        }, true);
      }
      console.log(res);
    }).catch((e: AxiosError<any, any>) => {
      const err = e as AxiosError<any>;
      FormUtil.setLaravelError(e, err);
    })
  };

  // 削除処理の確認
  const confirmDelete = (id: number) => {
    DialogService.warning({
      title: '雇用契約書を削除しますか？',
      text: 'この操作は取り消すことができません',
      confirmButtonText: 'はい',
      showCancelButton: true,
      cancelButtonText: 'キャンセル',
    }
    ).then((result) => {
      if (result.isConfirmed) {
        deleteKoyouKeiyaku(id);
      }
    })
  };

  return {
    confirmDelete,
  }
}

